import * as React from 'react';
import * as classNames from 'classnames';
import {StatelessComponent} from 'react';
import './styles.sass';

export interface ITooltipButtonHintProps {
  children?: any;
  type?: string;
  disabled?: boolean;
  visible?: boolean;
  placement?: string;
  rounded?: boolean;
  label: string;
}

export const Hint: StatelessComponent<ITooltipButtonHintProps> = ({
  children,
  visible,
  label,
  type,
  disabled = false,
  placement = 'top',
  rounded = true,
}: ITooltipButtonHintProps) => {
  const classes = classNames('hint__label', {
    'hint__label_rounded': rounded,
    'hint__label_disabled': disabled,
    'hint__label_visible': visible,
    [`hint__label_${placement}`]: placement,
    [`hint__label_${type}`]: type,
  });

  return (
    <div className={'hint'}>
      <div className={'hint__content'}>{children}</div>
      <div className={classes}>{label}</div>
    </div>
  );
};
